import React, { useEffect, useState } from "react";
import { timelineService } from "../../../../api/services/timelineService";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  timelineReducer,
  timelineReducerLoader,
} from "../../../../infra/aggregates/timelineSlice";

interface TimelineProps {
  setTimeline: (timeline: []) => void;
}

function DTOTimeline({ setTimeline }: TimelineProps) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  let timelineList: any = [];
  async function getTimeline(emp_id: number) {
    dispatch(timelineReducerLoader(true));
    const response = await timelineService.timeline(emp_id);

    if (response.response == "success") {
      timelineList = response.data;

      dispatch(timelineReducer(timelineList));
      setTimeline(timelineList);
      dispatch(timelineReducerLoader(false));
    } else {
      dispatch(timelineReducerLoader(false));
      return;
    }
  }
  useEffect(() => {
    const emp_id = selector.authSlice.emp_id;
    getTimeline(emp_id);
  }, []);

  return <></>;
}
export default DTOTimeline;
